// Google Analytics 4 measurement ID for the "Cosmik Drones" property
// (josh@cosmikdrones.com → analytics.google.com).
export const GA_MEASUREMENT_ID = 'G-1KC0SB843N';
export const GA_ENABLED = !GA_MEASUREMENT_ID.includes('XXXX');
